export enum Plan {
  FREE = "free",
  BASIC = "basic",
  GROWTH = "growth",
}